module.exports = __webpack_public_path__ + "static/adjustable-bed-frame-design-process-54bcc69e8c8b241c7342412233a4c5c4.mp4";